import React from "react";
import Slider from "react-slick";
import { Box, Typography } from "@mui/material";
import { ActivitiesInfo } from "../../api/HomeApi";
import SectionHeader from "./SectionHeader";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const style = {
  sliderItemWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxWidth: "548px",
  },
  logo: {
    maxWidth: "548px",
    width: "100%",
    //  height:"auto",
  },
  contentWrapper: {
    maxWidth: "548px",
    marginTop: "1.5rem",
  },
  text: {
    welcomeText2: {
      fontFamily: "ZapfHumnst BT",
      fontWeight: "400",
      fontSize: "16px",
      letterSpacing: "0.05em",
      color: "#181818",
    },
    welcomeText3: {
      fontFamily: "ZapfHumnst BT",
      fontWeight: "400",
      fontSize: "24px",
      letterSpacing: "0.05em",
      color: "#181818",
    },
    Description: {
      fontFamily: "Sora",
      fontWeight: "300",
      fontSize: "14px",
      letterSpacing: "1%",
      color: "#4C4C4C",
      marginTop: "1rem !important",
    },
  },
  textWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  cont: {
    width: {
      xs: "93%",
      sm: "93%",
      md: "100%",
      lg: "100%",
      xl: "100%",
    },
  },
};

const Activities = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    autoplaySpeed: 2000,
    easing: "ease-in-out",
    autoplay: true,
    dots:false,
    swipeToSlide: true,
    draggable: true,
    centerPadding: "250px",
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3.5,
          centerPadding: "100px",
          centerMode: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerPadding: "40px",
          centerMode: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerPadding: "50px",
          centerMode: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "10px",
          centerMode: true,
          swipeToSlide: true,
        },
      },
    ],
  };

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#fdf6ef",
        paddingTop: {
          xl: "70px",
          md: "70px",
          sm: "50px",
          xs: "50px",
        },
      }}
    >
      <SectionHeader
        title={"Activities"}
        description={"Experiences to Elevate Your Stay"}
      // ref={sectionHeader}
      />
      <Box sx={style.cont} mt={5} mb={5}>
        <Slider {...settings}>
          {ActivitiesInfo.map((slide, index) => (
            <Box key={index} sx={{ width: "95% !important" }}>
              <Box
                sx={style.logo}
                component="img"
                src={slide.src}
                alt={`Slide ${index}`}
              />
              <Box sx={style.contentWrapper}>
                <Box sx={style.textWrapper}>
                  <Typography sx={style.text.welcomeText2}>
                    {slide.Activity}
                  </Typography>
                  <Typography sx={style.text.welcomeText3}>
                    {slide.title}
                  </Typography>
                </Box>
                <Typography sx={style.text.Description}>
                  {slide.Description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default Activities;
